import styled, { css } from 'styled-components';
import logoAis from 'src/assets/images/logo.png';
import { media } from 'src/common/styles/breakpoints';
import { useVerificationId } from 'src/common/hooks/useVerificationId';
import { useGetPartnerLogoQuery } from '@tenant/components/Logo/useGetPartnerLogoQuery';

const LogoContainer = styled.header`
  grid-area: logo;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const StyledLogo = styled.img`
  max-height: 3rem;
  max-width: 8.75rem;
`;

const PartnerLogo = styled(StyledLogo)`
  margin-left: 1.5rem;

  ${media.w.min.px576(css`
    margin-left: 3rem;
  `)}
`;

export interface LogoProps {
  fetchPartnerLogo?: boolean;
  className?: string;
}

const Logo = ({ fetchPartnerLogo = true, className }: LogoProps) => {
  const verificationId = useVerificationId();
  const { data } = useGetPartnerLogoQuery({
    verificationId,
    enabled: fetchPartnerLogo,
  });

  return (
    <LogoContainer className={className}>
      <StyledLogo src={logoAis} alt="AIS Gateway" />
      {data ? <PartnerLogo src={data} /> : null}
    </LogoContainer>
  );
};

export default Logo;
